<div fxLayout="column" fxLayoutAlign="start stretch">
  <div fxLayout="column" fxLayoutAlign="start stretch">
    <div fxLayoutAlign="center center" class="header-container">
      <h2 mat-dialog-title>PERFIL CONTRIBUYENTE</h2>
      <button
        mat-icon-button
        aria-label="close dialog"
        mat-dialog-close
        class="close-button"
        color="warn"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <mat-dialog-content fxLayoutAlign="space-around center">
      <form
        name="form"
        *ngIf="form"
        [formGroup]="form"
        autocomplete="off"
        fxLayout="column"
        fxFlex="85"
      >
        <mat-form-field appearance="outline" color="accent">
          <mat-label>Tipo</mat-label>
          <mat-select formControlName="type">
            <mat-option [value]="1">Persona Natural</mat-option>
          </mat-select>
          <mat-icon
            matSuffix
            class="secondary-text"
            [matTooltip]="notification.type"
            [ngClass]="{ 'error-icon': controlHasError('type') }"
          >
            person
          </mat-icon>
        </mat-form-field>
        <div
            fxLayout="row"
            fxLayoutAlign="center"
            fxLayoutGap="10px">
          <mat-form-field 
            appearance="outline"
            fxFlex="50" 
            color="accent">
            <mat-label>Clase</mat-label>
            <mat-select
              formControlName="class"
              (openedChange)="switchSpecialNumber()"
            >
              <mat-option [value]="1">Otros</mat-option>
              <mat-option [value]="2">Especial</mat-option>
            </mat-select>
            <mat-icon
              matSuffix
              class="secondary-text"
              [matTooltip]="notification.class"
              [ngClass]="{ 'error-icon': controlHasError('class') }"
              >class</mat-icon
            >
          </mat-form-field>
          <mat-form-field 
            appearance="outline"
            fxFlex="50" 
            color="accent">
            <mat-label>N. Especial</mat-label>
            <input matInput formControlName="specialNumber" numbersOnly />
            <mat-icon
              matSuffix
              class="secondary-text"
              [matTooltip]="notification.specialNumber"
              [ngClass]="{ 'error-icon': controlHasError('specialNumber') }"
              >class</mat-icon
            >
          </mat-form-field>
        </div>
        <div
            fxLayout="row"
            fxLayoutAlign="center"
            fxLayoutGap="10px"
          >
          <mat-form-field
            appearance="outline"
            fxFlex="50" 
            color="accent"
            >
            <mat-label>Artesano</mat-label>
            <mat-select
              formControlName="artisan"
              (openedChange)="switchArtisanNumber()"
            >
              <mat-option [value]="true">Si</mat-option>
              <mat-option [value]="false">No</mat-option>
            </mat-select>
            <mat-icon
              matSuffix
              class="secondary-text"
              [matTooltip]="notification.artisan"
              [ngClass]="{ 'error-icon': controlHasError('artisan') }"
              >class</mat-icon
            >
          </mat-form-field>
          <mat-form-field 
            appearance="outline"
            fxFlex="50" 
            color="accent"
          >
            <mat-label>N. Artesano</mat-label>
            <input
              matInput
              formControlName="artisanNumber"
              numbersOnly 
            />
            <mat-icon
              matSuffix
              class="secondary-text"
              [matTooltip]="notification.artisanNumber"
              [ngClass]="{ 'error-icon': controlHasError('artisanNumber') }"
              >class</mat-icon
            >
          </mat-form-field>
        </div>
        <mat-form-field appearance="outline" color="accent">
          <mat-label>Obligado Contabilidad</mat-label>
          <mat-select formControlName="obligatoryAccounting">
            <mat-option [value]="true">Si</mat-option>
            <mat-option [value]="false">No</mat-option>
          </mat-select>
          <mat-icon
            matSuffix
            class="secondary-text"
            [matTooltip]="notification.obligatoryAccounting"
            [ngClass]="{
              'error-icon': controlHasError('obligatoryAccounting'),
            }"
          >
            class
          </mat-icon>
        </mat-form-field>
      </form>
    </mat-dialog-content>

    <mat-dialog-actions fxLayout="row" fxLayoutAlign="center">
      <button
        mat-raised-button
        (click)="save()"
        [disabled]="!form.valid || isLoading"
        color="accent"
        class="submit-button w-button"
      >
        <div *ngIf="isLoading" class="loadingComponent">
          <app-loading [isLoading]="isLoading" />
        </div>
        <span *ngIf="!isLoading">{{ txtBtn }}</span>
      </button>
    </mat-dialog-actions>
  </div>
</div>
